<template>
  <div>
    <div class="row">
      <div id="warehouse" class="col p-2 box">
        <h5 class="text-white">Warehouse Items</h5>
        <div class="row m-0 mb-1">
          <input
            type="text"
            placeholder="Search"
            id="search"
            class="text-center m-auto"
            autocomplete="off"
            :class="{
              'w-25': !searching,
              'w-75': searching,
            }"
            @focus="searching = true"
            @blur="searching = false"
            @input="search($event.target.value)"
            style="border: none; border-radius: 25px; outline: none; text-overflow: ellipsis;"
          />
        </div>
        <div class="row m-0">
          <div class="col-3" style="font-size: 14px; color: gainsboro;">
            Invoice
          </div>
          <div class="col" style="font-size: 14px; color: gainsboro;">
            Shipper
          </div>
          <div class="col" style="font-size: 14px; color: gainsboro;">
            Consignee
          </div>
          <div class="col" style="font-size: 14px; color: gainsboro;">
            Airport Code
          </div>
          <div class="col" style="font-size: 14px; color: gainsboro;">
              Status
            </div>
        </div>
        <div v-if="loadingFlag" class="d-flex align-items-center justify-content-center">
          <Loading />
        </div>
        <div v-else-if="items.warehouse.length === 0">
          No more items.
        </div>
        <draggable
          v-model="items.warehouse"
          group="shared"
          @start="drag = true"
          @end="drag = false"
          animation="150"
          selected-class="selected"
          ghost-class="ghostItem"
          multi-drag
          multi-drag-key="ALT"
          class="inner-box"
          style="height: 522px;"
        >
          <ContainerWidgetItem
            v-for="item in items.warehouse"
            v-show="resultIds.has(item.id)"
            :item="item"
            :key="item.id"
          >
          </ContainerWidgetItem>
        </draggable>
      </div>
      <div class="col-1 m-auto" style="max-width: 78px;">
        <b-icon-caret-right-fill
          font-scale="2"
          @mousedown="moveItems()"
        ></b-icon-caret-right-fill>
        <b-icon-caret-left-fill
          font-scale="2"
          @mousedown="moveItems(false)"
        ></b-icon-caret-left-fill>
      </div>
      <div class="col p-2 box" id="active-container" style="overflow: hidden;">
        <div v-if="active === ''">
          Add container
        </div>
        <div
          v-for="(container) in items.container"
          v-show="container.id === active"
          :key="container.id"
        >
          <h5 class="text-white">
            Container
            <u data-toggle="tooltip" data-placement="top" :title="name"> ... </u
            >{{ lastFour(container.name)  }}
            ({{ container.containerSize }})
            <button
              type="button"
              class="btn mr-2 h6 p-0 mt-1 px-2"
              :class="clearConfirmation === 1 ? 'btn-danger' : 'btn-light'"
              style="vertical-align: bottom; float: right; user-select: none; font-size: small;"
              @click="clearActive()"
              @blur="clearConfirmation = 0"
            >
              Clear
            </button>
          </h5>
          <div class="row m-0 w-100">
            <div class="col-3" style="font-size: 14px; color: gainsboro;">
              Invoice
            </div>
            <div class="col" style="font-size: 14px; color: gainsboro;">
              Shipper
            </div>
            <div class="col" style="font-size: 14px; color: gainsboro;">
              Consignee
            </div>
            <div class="col" style="font-size: 14px; color: gainsboro;">
              Airport Code
            </div>
            <div class="col" style="font-size: 14px; color: gainsboro;">
              Status
            </div>
          </div>
          <!-- items[active].length === 0 -->
          <div v-if="active && container.item.length === 0">
            No more items.
          </div>
          <draggable
            v-if="active !== ''"
            v-model="container.item"
            group="shared"
            @start="drag = true"
            @end="drag = false"
            animation="150"
            selected-class="selected"
            ghost-class="ghostItem"
            multi-drag
            multi-drag-key="ALT"
            class="inner-box"
            :key="container.id"
          >
            <ContainerWidgetItem
              v-for="item in container.item"
              :item="item"
              :key="item.id"
            >
            </ContainerWidgetItem>
          </draggable>
        </div>
        <div class="row pt-1">
          <div class="col-4">
            <span class="badge badge-pill badge-primary"
              >{{ activeRecords }} Items</span
            >
          </div>
          <div class="col-4">
            <span class="badge badge-pill badge-warning"
              >{{ activeWeight }} lbs</span
            >
          </div>
          <div class="col-4">
            <span class="badge badge-pill badge-success"
              >{{ activeVolume }} in<sup>3</sup></span
            >
          </div>
        </div>
        <hr style="border-top: 2px solid rgba(255,255,255,.3);" />
        <div id="boxes" class="row m-0 mt-2">
          <div class="col-10 p-0">
            <div class="row m-auto flex-nowrap" style="overflow-x: auto;">
              <ContainerWidgetSummary
                v-for="(container) in items.container"
                :item="container"
                :name="container.name"
                :key="container.id"
                v-model="active"
                @remove_container="removeContainer"
                @edit_container="editContainer"
                @lock_container="lockContainer"
                class="mr-1 col-5"
              ></ContainerWidgetSummary>
            </div>
          </div>
          <div class="col-2 pl-2 pr-0">
            <b-button
              v-b-modal.new-container
              variant="light"
              class="p-0"
              style="width: 100%; height: 100%;"
            >
              Add
            </b-button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal -->
    <b-modal
      id="new-container"
      @shown="initFormlessFloatingLabels()"
      @ok="addContainer"
    >
      <template v-slot:modal-title>
        Add Container
      </template>
      <template v-slot:default>
        <div class="floating-label-container position-relative text-center">
          <div style="max-width: 30%;">
            <b-form-checkbox
              class="text-left"
              id="vehicle"
              v-model="container.vehicle"
            >
              Vehicle
            </b-form-checkbox>
            <b-row>
              <b-col>
                <b-form-select
                  v-if="!container.vehicle"
                  required
                  id="container-type"
                  v-model="container.containerType"
                  :options="containerTypes"
                  class="text-center"
                  @change="updateContainerSelected"
                ></b-form-select>
              </b-col>
            </b-row>
          </div>
          <form ref="name" @submit.stop.prevent="addContainer">
            <b-form-group
                label="Container Name"
                label-for="containerName"
                :state="containerState.nameState"
            >
              <b-form-input
                id="containerName"
                v-model="container.name"
                :state="containerState.nameState"
                required
              ></b-form-input>
            </b-form-group>
          </form>

          <form ref="description" @submit.stop.prevent="addContainer">
            <b-form-group
                label="Container Description"
                label-for="containerDescription"
                :state="containerState.descriptionState"
            >
              <b-form-input
                id="containerDescription"
                v-model="container.description"
                :state="containerState.descriptionState"
                required
              ></b-form-input>
            </b-form-group>
          </form>

          <form v-if="container.vehicle" ref="vehicleModel" @submit.stop.prevent="addContainer">
            <b-form-group
                label="Vehicle Model"
                label-for="vehicleModel"
                :state="containerState.vehicleModelState"
            >
              <b-form-input
                id="vehicleModel"
                v-model="container.vehicleModel"
                :state="containerState.vehicleModelState"
                required
              ></b-form-input>
            </b-form-group>
          </form>
          <form v-if="container.vehicle" ref="vin" @submit.stop.prevent="addContainer">
            <b-form-group
                label="VIN"
                label-for="VIN"
                :state="containerState.vinState"
            >
              <b-form-input
                id="vin"
                v-model="container.vin"
                :state="containerState.vinState"
                required
              ></b-form-input>
            </b-form-group>
          </form>

          <b-form-row v-if="!container.vehicle" class="justify-content-center">
            <b-col>
              <form ref="length" @submit.stop.prevent="addContainer">
                <b-form-group
                  label="Container Length"
                  label-for="containerLength"
                  :state="containerState.lengthState"
                >
                  <b-form-input
                    id="containerLength"
                    number
                    type="number"
                    step="0.01"
                    min="0.0"
                    v-model="container.containerLength"
                    :state="containerState.lengthState"
                    required
                  ></b-form-input>
                </b-form-group>
              </form>
            </b-col>
            <b-col cols="auto" class="d-flex align-items-center">
              <b-icon-x></b-icon-x>
            </b-col>
            <b-col>
              <form ref="width" @submit.stop.prevent="addContainer">
                <b-form-group
                  label="Container Width"
                  label-for="containerWidth"
                  :state="containerState.widthState"
                >
                  <b-form-input
                    id="containerWidth"
                    number
                    type="number"
                    step="0.01"
                    min="0.0"
                    v-model="container.containerWidth"
                    :state="containerState.widthState"
                    required
                  ></b-form-input>
                </b-form-group>
              </form>
            </b-col>
            <b-col cols="auto" class="d-flex align-items-center">
              <b-icon-x></b-icon-x>
            </b-col>
            <b-col>
              <form ref="height" @submit.stop.prevent="addContainer">
                <b-form-group
                  label="Container Height"
                  label-for="containerHeight"
                  :state="containerState.heightState"
                >
                  <b-form-input
                    id="containerHeight"
                    number
                    type="number"
                    step="0.01"
                    min="0.0"
                    v-model="container.containerHeight"
                    :state="containerState.heightState"
                    required
                  ></b-form-input>
                </b-form-group>
              </form>
            </b-col>
            <b-col>
             <b-form-group
                  label="Measurement Type"
                  label-for="containerMeasurement"
            >
            <b-form-select
              id="containerMeasurement"
              v-model="container.selectedMeasureType"
              :options="optionsMeasureType"
            ></b-form-select>
            </b-form-group>
            </b-col>
          </b-form-row>

          <form ref="seal" @submit.stop.prevent="addContainer">
            <b-form-group
                label="Seal"
                label-for="containerSeal"
                :state="containerState.sealState"
            >
              <b-form-input
                id="containerSeal"
                v-model="container.containerSeal"
                :state="containerState.sealState"
                required
              ></b-form-input>
            </b-form-group>
          </form>

          <form ref="hts" @submit.stop.prevent="addContainer">
            <b-form-group
                label="HTS Code"
                label-for="containerHTS"
                :state="containerState.sealState"
            >
              <b-form-input
                id="containerHTS"
                v-model="container.containerHTS"
                :state="containerState.htsState"
                required
              ></b-form-input>
            </b-form-group>
          </form>
        </div>
      </template>
    </b-modal>

    <!-- Modal -->
    <b-modal
      id="edit-container"
      @shown="initFormlessFloatingLabels()"
      @ok="modifyContainer"
    >
      <template v-slot:modal-title>
        Edit Container
      </template>
      <template v-slot:default>
        <div class="floating-label-container position-relative text-center">
          <div style="max-width: 30%;">
            <b-form-checkbox
              class="text-left"
              id="vehicle"
              v-model="container.vehicle"
            >
              Vehicle
            </b-form-checkbox>
            <b-row>
              <b-col>
                <b-form-select
                  v-if="!container.vehicle"
                  required
                  id="container-type"
                  v-model="container.containerType"
                  :options="containerTypes"
                  class="text-center"
                  @change="updateContainerSelected"
                ></b-form-select>
              </b-col>
            </b-row>
          </div>
          <form ref="name" @submit.stop.prevent="addContainer">
            <b-form-group
                label="Container Name"
                label-for="containerName"
                :state="containerState.nameState"
            >
              <b-form-input
                id="containerName"
                v-model="container.name"
                :state="containerState.nameState"
                required
              ></b-form-input>
            </b-form-group>
          </form>

          <form ref="description" @submit.stop.prevent="addContainer">
            <b-form-group
                label="Container Description"
                label-for="containerDescription"
                :state="containerState.descriptionState"
            >
              <b-form-input
                id="containerDescription"
                v-model="container.description"
                :state="containerState.descriptionState"
                required
              ></b-form-input>
            </b-form-group>
          </form>

          <form v-if="container.vehicle" ref="vehicleModel" @submit.stop.prevent="addContainer">
            <b-form-group
                label="Vehicle Model"
                label-for="vehicleModel"
                :state="containerState.vehicleModelState"
            >
              <b-form-input
                id="vehicleModel"
                v-model="container.vehicleModel"
                :state="containerState.vehicleModelState"
                required
              ></b-form-input>
            </b-form-group>
          </form>
          <form v-if="container.vehicle" ref="vin" @submit.stop.prevent="addContainer">
            <b-form-group
                label="VIN"
                label-for="VIN"
                :state="containerState.vinState"
            >
              <b-form-input
                id="vin"
                v-model="container.vin"
                :state="containerState.vinState"
                required
              ></b-form-input>
            </b-form-group>
          </form>
          <b-form-row v-if="!container.vehicle" class="justify-content-center">
            <b-col>
              <form ref="length" @submit.stop.prevent="addContainer">
                <b-form-group
                  label="Container Length"
                  label-for="containerLength"
                  :state="containerState.lengthState"
                >
                  <b-form-input
                    id="containerLength"
                    number
                    type="number"
                    step="0.01"
                    min="0.0"
                    v-model="container.containerLength"
                    :state="containerState.lengthState"
                    required
                  ></b-form-input>
                </b-form-group>
              </form>
            </b-col>
            <b-col cols="auto" class="d-flex align-items-center">
              <b-icon-x></b-icon-x>
            </b-col>
            <b-col>
              <form ref="width" @submit.stop.prevent="addContainer">
                <b-form-group
                  label="Container Width"
                  label-for="containerWidth"
                  :state="containerState.widthState"
                >
                  <b-form-input
                    id="containerWidth"
                    number
                    type="number"
                    step="0.01"
                    min="0.0"
                    v-model="container.containerWidth"
                    :state="containerState.widthState"
                    required
                  ></b-form-input>
                </b-form-group>
              </form>
            </b-col>
            <b-col cols="auto" class="d-flex align-items-center">
              <b-icon-x></b-icon-x>
            </b-col>
            <b-col>
              <form ref="height" @submit.stop.prevent="addContainer">
                <b-form-group
                  label="Container Height"
                  label-for="containerHeight"
                  :state="containerState.heightState"
                >
                  <b-form-input
                    id="containerHeight"
                    number
                    type="number"
                    step="0.01"
                    min="0.0"
                    v-model="container.containerHeight"
                    :state="containerState.heightState"
                    required
                  ></b-form-input>
                </b-form-group>
              </form>
            </b-col>
            <b-col>
             <b-form-group
                  label="Measurement Type"
                  label-for="containerMeasurement"
            >
            <b-form-select
              id="containerMeasurement"
              v-model="container.selectedMeasureType"
              :options="optionsMeasureType"
            ></b-form-select>
            </b-form-group>
            </b-col>
          </b-form-row>

          <form ref="seal" @submit.stop.prevent="addContainer">
            <b-form-group
                label="Seal"
                label-for="containerSeal"
                :state="containerState.sealState"
            >
              <b-form-input
                id="containerSeal"
                v-model="container.containerSeal"
                :state="containerState.sealState"
                required
              ></b-form-input>
            </b-form-group>
          </form>

          <form ref="hts" @submit.stop.prevent="addContainer">
            <b-form-group
                label="HTS Code"
                label-for="containerHTS"
                :state="containerState.sealState"
            >
              <b-form-input
                id="containerHTS"
                v-model="container.containerHTS"
                :state="containerState.htsState"
                required
              ></b-form-input>
            </b-form-group>
          </form>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import Fuse from 'fuse.js';
// import Vue from 'vue';
import draggable from '../assets/js/vuedraggable.umd.min';
import ContainerWidgetItem from './ContainerWidgetItem.vue';
import ContainerWidgetSummary from './ContainerWidgetSummary.vue';
import { postContainer, deleteContainer, updateContainer } from '../api/manifest';
import Loading from './Loading.vue';

export default {
  name: 'ContainerWidget',
  props: ['items', 'billOfLading', 'loadingFlag', 'active'],
  data() {
    return {
      // active: '',
      chosen: [],
      drag: false,
      searching: false,
      results: [],
      containerState: {
        nameState: null,
        descriptionState: null,
        lengthState: null,
        heightState: null,
        widthState: null,
        sealState: null,
        htsState: null,
        vinState: null,
        vehicleModelState: null,
      },
      container: {
        name: '',
        description: '',
        containerSize: '',
        containerLength: 0,
        containerWidth: 0,
        containerHeight: 0,
        containerSeal: '',
        containerHTS: '',
        vehicle: false,
        vin: '',
        vehicleModel: '',
        containerType: null,
        selectedMeasureType: 'ft',
        billOfLading: this.billOfLading,
        item: [],
      },
      optionsMeasureType: [
        { value: 'ft', text: 'feet' },
        // { value: 'in', text: 'in' },
        // { value: 'm', text: 'meters' },
      ],
      containerTypes: [
        {
          value: null, text: 'Container Type', length: 0, height: 0, width: 0,
        },
        {
          value: '20 dry', text: '20 DRY', length: 19.4, height: 7.9, width: 7.8,
        },
        {
          value: '40 dry', text: '40 DRY', length: 39.5, height: 7.9, width: 7.9,
        },
        {
          value: '45 dry', text: '45 DRY', length: 44.5, height: 8.9, width: 7.8,
        },
        {
          value: '40 high cube', text: '40 HIGH CUBE', length: 39.5, height: 8.9, width: 7.8,
        },
        {
          value: '45 high cube', text: '45 HIGH CUBE', length: 44.5, height: 8.9, width: 7.8,
        },
        {
          value: 'break bulk', text: 'BREAK BULK', length: 0, height: 0, width: 0,
        },
      ],
      clearConfirmation: 0,
    };
  },
  computed: {
    resultIds() {
      return this.results.length === 0
        ? new Set(this.items.warehouse.map((item) => item.id))
        : new Set(this.results.map((result) => result.item.id));
    },
    activeRecords() {
      if (this.active === '') {
        return 0;
      }
      return this.items.container.find((container) => container.id === this.active).item.length;
      // return this.items[this.active].length;
    },
    activeWeight() {
      if (this.active === '') {
        return 0;
      }
      return this.items.container.find(
        (container) => container.id === this.active,
      ).item.reduce(
        (accumulator, currentValue) => accumulator + currentValue.weight,
        0,
      );
      // return this.items[this.active].reduce(
      //   (accumulator, currentValue) => accumulator + currentValue.weight,
      //   0,
      // );
    },
    activeVolume() {
      if (this.active === '') {
        return 0;
      }
      return this.items.container.find(
        (container) => container.id === this.active,
      ).item.reduce(
        (accumulator, currentValue) => accumulator + currentValue.volume,
        0,
      );
      // return this.items[this.active].reduce(
      //   (accumulator, currentValue) => accumulator + currentValue.volume,
      //   0,
      // );
    },
    fuse() {
      return new Fuse(this.items.warehouse, {
        keys: ['id', 'consignee', 'shipper', 'airportCode', 'weight', 'volume'],
      });
    },
  },
  methods: {
    updateContainerSelected(value) {
      const selected = this.containerTypes.find((container) => container.value === value);
      this.container.containerLength = selected.length;
      this.container.containerWidth = selected.width;
      this.container.containerHeight = selected.height;
    },
    search(term) {
      this.results = this.fuse.search(term);
    },
    resetModal() {
      this.container.containerType = null;
      this.container.vehicle = false;
      this.container.vin = '';
      this.container.vehicleModel = '';
      this.container.name = '';
      this.container.description = '';
      this.container.containerSize = '';
      this.container.containerSeal = '';
      this.container.containerHTS = '';
      this.container.containerLength = 0;
      this.container.containerWidth = 0;
      this.container.containerHeight = 0;
      this.container.selectedMeasureType = 'ft';
      Object.keys(this.containerState).forEach((key) => {
        this.containerState[key] = null;
      });
    },
    checkFormValidity() {
      this.containerState.nameState = this.$refs.name.checkValidity();
      this.containerState.descriptionState = this.$refs.description.checkValidity();
      if (!this.container.vehicle) {
        this.containerState.lengthState = this.$refs.length.checkValidity();
        this.containerState.widthState = this.$refs.width.checkValidity();
        this.containerState.heightState = this.$refs.height.checkValidity();
      }
      if (this.container.vehicle) {
        this.containerState.vehicleModelState = this.$refs.vehicleModel.checkValidity();
        this.containerState.vinState = this.$refs.vin.checkValidity();
      }
      this.containerState.sealState = this.$refs.seal.checkValidity();
      this.containerState.htsState = this.$refs.hts.checkValidity();
      let valid = true;
      Object.values(this.containerState).forEach((value) => {
        if (value === false) {
          valid = false;
        }
      });

      return valid;
    },
    lastFour(str) {
      return str.slice(str.length - 4);
    },
    addContainer(bvModalEvt) {
      bvModalEvt.preventDefault();

      if (!this.checkFormValidity()) {
        return;
      }

      this.container.containerSize = `${this.container.containerLength} x ${this.container.containerWidth} x ${this.container.containerHeight} ${this.container.selectedMeasureType}`;
      const copy = Object.keys(this.container).reduce((acc, curr) => {
        if (typeof this.container[curr] === 'string') {
          acc[curr] = this.container[curr].trim();
        } else {
          acc[curr] = this.container[curr];
        }
        return acc;
      }, {});
      const data = { data: { ...copy } };
      postContainer(data)
        .then((resp) => {
          console.log('Successfully POSTed');
          console.log(resp);
          this.$nextTick(() => {
            this.$bvModal.hide('new-container');
          });
          // if (this.items.container.find((item) => item.name === container.name) === undefined) {
          //   this.items.container.push({ ...container, id: resp.data.id });
          // }
          this.items.container.push({ ...this.container, id: resp.data.id });
        }).catch((err) => {
          console.log(err);
        });
    },
    removeContainer(container) {
      const data = { data: { ...container } };
      deleteContainer(data)
        .then((resp) => {
          console.log('Successfully DELETEed');
          console.log(resp);
          container.item.forEach(
            (elem) => this.items.warehouse.push(elem),
          );
          this.items.container = this.items.container.filter(
            (item) => item.id !== container.id,
          );
          // Vue.delete(this.items, container);
          if (container.id === this.active) {
            this.active = '';
          }
          this.clearContainer = 0;
        }).catch((err) => {
          console.log(err);
        });
    },
    editContainer(container) {
      this.container = container;
      this.container.selectedMeasureType = 'ft';
      this.$bvModal.show('edit-container');
    },
    lockContainer(container) {
      this.container = container;
      this.container.lock = !container.lock;
      const data = { data: { ...this.container } };
      updateContainer(data)
        .then((resp) => {
          console.log('Successfully POSTed');
          console.log(resp);
          // this.$nextTick(() => {
          //   this.$bvModal.hide('edit-container');
          // });
        }).catch((err) => {
          console.log(err);
        });
    },
    modifyContainer(bvModalEvt) {
      bvModalEvt.preventDefault();

      if (!this.checkFormValidity()) {
        return;
      }

      this.container.containerSize = `${this.container.containerLength} x ${this.container.containerWidth} x ${this.container.containerHeight} ${this.container.selectedMeasureType}`;
      const copy = Object.keys(this.container).reduce((acc, curr) => {
        if (typeof this.container[curr] === 'string') {
          acc[curr] = this.container[curr].trim();
        } else {
          acc[curr] = this.container[curr];
        }
        return acc;
      }, {});
      const data = { data: { ...copy } };
      updateContainer(data)
        .then((resp) => {
          console.log('Successfully POSTed');
          console.log(resp);
          this.$nextTick(() => {
            this.$bvModal.hide('edit-container');
          });
        }).catch((err) => {
          console.log(err);
        });
    },
    moveItems(from = true) {
      if (this.active === '') {
        return;
      }
      let source;
      let destination;
      let selected;
      if (from) {
        source = 'warehouse';
        destination = this.active;
        selected = [...document.getElementsByClassName('selected')]
          .map((elem) => +elem.dataset.bol)
          .filter((bol) => this.items[source].find((elem) => elem.id === bol));
        const container = this.items.container.find((item) => item.id === destination);
        container.item = [].concat(
          this.items[source].filter((elem) => selected.includes(elem.id)),
          container.item,
        );
        this.items[source] = this.items[source].filter(
          (elem) => !selected.includes(elem.id),
        );
      } else {
        source = this.active;
        destination = 'warehouse';
        const container = this.items.container.find((item) => item.id === source);
        selected = [...document.getElementsByClassName('selected')]
          .map((elem) => +elem.dataset.bol)
          .filter((bol) => container.item.find((elem) => elem.id === bol));
        this.items[destination] = [].concat(
          container.item.filter((elem) => selected.includes(elem.id)),
          this.items[destination],
        );
        container.item = container.item.filter(
          (elem) => !selected.includes(elem.id),
        );
      }
    },
    clearActive() {
      if (this.active === '') {
        return;
      }
      if (this.clearConfirmation === 1) {
        const container = this.items.container.find((item) => item.id === this.active);
        container.item.forEach(
          (elem) => this.items.warehouse.push(elem),
        );
        const splice = container.item.splice(
          0, container.length,
        );
        this.items.container.find((item) => item.id === this.active).item = splice;
        // this.items[this.active].forEach((elem) => this.items.warehouse.push(elem));
        // this.items[this.active].splice(0, this.items[this.active].length);
        this.clearConfirmation = 0;
      } else {
        this.clearConfirmation = 1;
      }
    },
  },
  created() {
    console.log(this.items.warehouse);
  },
  mounted() {
    this.initFormlessFloatingLabels();
  },
  components: {
    ContainerWidgetSummary,
    ContainerWidgetItem,
    draggable,
    Loading,
  },
};
</script>

<style scoped>
.box {
  background: rgb(61, 89, 161);
  background: linear-gradient(
    135deg,
    rgba(61, 89, 161, 1) 0%,
    rgba(101, 143, 185, 1) 100%
  );
  color: white;
  border-radius: 10px;
  overflow: auto;
}

#search {
  transition: width 200ms ease;
}

[v-cloak] {
  display: none;
}

/* .selected, .sortable-chosen {
  background: #dbe5f5 !important;
} */

.selected, .sortable-chosen, .ghostItem {
  background: #dbe5f5;
  background: linear-gradient(-45deg, transparent 25%, #dbe5f5 25%, #dbe5f5 50%,
    transparent 50%, transparent 75%, #dbe5f5 75%);
  background-size: 27px 27px;
  animation: barberpole 15s infinite linear;
}

@-webkit-keyframes barberpole {
  from {background-position: 0;}
  to {background-position: 100%;}
}

.inner-box {
  height: 450px;
  overflow: auto;
}

.item {
  background-color: white;
  color: black;
  border-radius: 5px !important;
  padding: 5px 0;
  width: 100%;
  margin: auto auto 5px;
}

.item div {
  user-select: none;
}
</style>
